// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'New Window';

export function NewWindow() {
  return (
    <svg
      aria-label={TITLE}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <title>{TITLE}</title>
      <path
        d="M12.6667 12.6667H3.33333V3.33333H8V2H2V14H14V8H12.6667V12.6667ZM9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2H9.33333Z"
        fill="currentColor"
      />
    </svg>
  );
}
